module.exports = __webpack_public_path__ + "media/images/flags/GB-ENG-79e5eeef9a1256d3deda22d25ecb8258.svg";